import { ReactNode, useContext } from "react";
import { useStore } from "../../state/state.ts";
import TextInput from "./input-text.tsx";
import { PropertiesAutoFillState } from "../../state/types.ts";
import { ConfigContext } from "../../config_context.ts";

export default function InputHouseNumber(props: {
    auto_filled?: PropertiesAutoFillState,
    infoButton?: ReactNode,
    label?: string,
    step?: number,
    unit?: string,
    value: string,
    placeholder?: string,
    onChange: (value: string | undefined) => void,
    onBlur?: () => void,
}) {
    //const api_building_geometry = useStore((state) => state.api_building_geometry);
    //const building_geometry_api = useContext(ConfigContext).building_geometry_api;
    const building_geometry_candidates = useStore((state) => state.building_geometry_candidates);
    
    return <TextInput
        auto_filled={props.auto_filled}
        validate={async (v) => (v.match(/^\d*[a-z]?$/g) ?? []).length > 0}
        infoButton={props.infoButton}
        label={props.label}
        step={props.step}
        unit={props.unit}
        hint_static={building_geometry_candidates && building_geometry_candidates.length > 0 ? "Der Hausnummer kann kein eindeutiges Gebäude zugeordnet werden. Mögliche Zusätze sind " + building_geometry_candidates.map(c => c.adz).join(', ') : ""}
        value={props.value ?? ""}
        placeholder={props.placeholder}
        onChange={props.onChange}
        onBlur={async () => {
            props.onBlur?.();
            // if (building_geometry_api) {
            //     await api_building_geometry();
            // }
        }}
    />;
}
